/* eslint-disable  @typescript-eslint/no-explicit-any */

import React, { useEffect, useRef } from 'react'
import { Table } from 'reactstrap'
import { useTranslation } from 'react-i18next'

import getCalendarMappingObject from '../helpers/calendarMappingObject'
import { countRateTotal, countRate } from '../helpers/countRates'

import { Columns, TotalPaymentPeriod } from './types'

type ArtistsPaymentPeriodProps = {
  paymentPeriod: TotalPaymentPeriod
  handleGetPaymentPeriod: (pickerRanges: any) => void
  pickerRanges: any
}

export const ArtistsPaymentPeriod: React.FunctionComponent<ArtistsPaymentPeriodProps> = ({
  paymentPeriod,
  handleGetPaymentPeriod,
  pickerRanges,
}) => {
  const { t } = useTranslation()

  useEffect(() => {
    handleGetPaymentPeriod(pickerRanges)
  }, [])

  /**
   * @@@ define  and count values "Total" row
   */
  const createdRef = useRef(0)
  let { current: createdTotal } = createdRef
  const paidRef = useRef(0)
  let { current: paidTotal } = paidRef
  const paymentRateRef = useRef(0)
  let { current: paymentRateTotal } = paymentRateRef

  /**
   * @@@ map a data object to the calendar
   */
  const calendar = getCalendarMappingObject(pickerRanges)

  const createdObj = Object.entries({
    ...calendar,
    ...paymentPeriod.created,
  })
    .reverse()
    .map(([date, created]) => ({ date, created }))

  const paidObj = Object.entries({
    ...calendar,
    ...paymentPeriod.paid,
  })
    .reverse()
    .map(([date, paid]) => ({ date, paid }))

  /**
   * @@@ complete the "table" array for render
   */
  const table: Columns[] = []
  Object.keys(paidObj).forEach(k => {
    const i = Number(k)

    const createdValue = createdObj[i].created
    const paidValue = paidObj[i].paid

    // count Total values
    createdTotal += createdValue
    paidTotal += paidValue
    paymentRateTotal = Number(countRateTotal(paidTotal, createdTotal))

    // count Rate
    const paymentRate = countRate('paymentRate', paidValue, createdValue)

    table[i] = Object.assign(createdObj[i], paidObj[i], paymentRate)
  })

  return (
    <div style={{ paddingRight: '30%' }}>
      <Table responsive striped>
        <thead>
          <tr>
            <th style={{ width: '34%' }} />
            <th style={{ width: '25%', textAlign: 'center' }}>
              {t('analytics.created')}
            </th>
            <th style={{ width: '19%', textAlign: 'center' }}>
              {t('analytics.paid')}
            </th>
            <th style={{ width: '29%', textAlign: 'center' }}>
              {t('analytics.paymentRate')}
            </th>
            <th style={{ width: '40%' }} />
          </tr>
        </thead>

        <tbody>
          <tr style={{ borderBottom: '2px solid #a6afb42b' }}>
            <td style={{ width: '34%' }}>Total</td>
            <td style={{ width: '25%', textAlign: 'center' }}>
              {createdTotal}
            </td>
            <td style={{ width: '19%', textAlign: 'center' }}>{paidTotal}</td>
            <td style={{ width: '29%', textAlign: 'center' }}>
              {paymentRateTotal}
            </td>
            <td style={{ width: '40%' }} />
          </tr>
          {table.slice(1).map(row => (
            <tr key={row.date}>
              <td style={{ width: '34%' }}>{row.date}</td>
              <td style={{ width: '25%', textAlign: 'center' }}>
                {row.created}
              </td>
              <td style={{ width: '19%', textAlign: 'center' }}>{row.paid}</td>
              <td style={{ width: '29%', textAlign: 'center' }}>
                {row.paymentRate}
              </td>
              <td style={{ minWidth: '40%' }} />
            </tr>
          ))}
        </tbody>
      </Table>

      <div className="pagination-bottom" />
    </div>
  )
}
